import { identity } from "./utils";
export const vars = {
    endpoints: [],
    resource: {
        attributes: [],
    },
    scope: {
        name: "dash0-web-sdk",
        version: __sdkVersion,
        attributes: [],
    },
    signalAttributes: [],
    ignoreUrls: [],
    ignoreErrorMessages: [],
    wrapEventHandlers: true,
    wrapTimers: true,
    propagateTraceHeadersCorsURLs: [],
    maxWaitForResourceTimingsMillis: 10000,
    maxToleranceForResourceTimingsMillis: 50,
    headersToCapture: [],
    urlAttributeScrubber: identity,
    pageViewInstrumentation: {
        trackVirtualPageViews: true,
        includeParts: [],
    },
    sessionRecording: {
        samplingRate: 100,
        maskAllInputs: true,
        maskTextClass: "dash0-mask",
        blockClass: "dash0-block",
        recordCanvas: false,
        collectFonts: false,
        chunkMaxBytes: 48000,
        chunkMaxMillis: 5000,
        checkoutEveryNms: 300000,
    },
    frustrationSignals: {
        rageClick: {
            minClicks: 3,
            windowMillis: 1000,
            radiusPixels: 30,
        },
    },
    enableTransportCompression: false,
    isSessionSampled: true,
};
